import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityAppMeetingSolutionOverviewVO } from '../Type/PackEntityAppMeetingSolutionOverviewVO'

interface DataModel {
	aid?: string
	cid?: string
}

/**
 *	查询应用当前的会议解决方案总览信息
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] 应用id
 * @param {string} [data.cid] 企业id
 */

export function meetingSolutionoverview(
	data: DataModel,
	options: IRequestOptionsWithPass,
): Promise<PackEntityAppMeetingSolutionOverviewVO>
export function meetingSolutionoverview(
	data: DataModel,
	options?: IRequestOptions,
): Promise<
	PackEntityAppMeetingSolutionOverviewVO extends { msg: unknown }
		? PackEntityAppMeetingSolutionOverviewVO['msg']
		: undefined
>
export function meetingSolutionoverview(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid, cid } = data
	return net('/frontApi/app/meetingSolution/overview', {
		method: 'post',
		params: {
			aid,
			cid,
		},

		...(options || {}),
	})
}
